/**React imports */
import React, { useEffect, Fragment, useState } from 'react';
/**Router */
import { Link } from 'react-router-dom';
/**Css styles */
import '../Navigation.css';

import logodv from '../assets/icons/logodv.png';

/**Transitions */
import Paper from '@material-ui/core/Paper';
import { Button, Fade } from '@material-ui/core';

import CardService from './CardService';
import Swal from 'sweetalert2'
import { db } from '../firebase'




const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500
});




const DashboardAdmin = () => {

    const [link, setLink] = useState('');




    const handleVideoLinkChange = (e) => {
        const { value } = e.target;
        setLink(value)
    }

    const addOrEditLink = async () => {



        var today = new Date();

        const linkObject = {
            link: `https://www.youtube.com/embed/${link}`,
            date: today
        }
        try {

           
       
            if (link !== "") {
                document.querySelector("#iLink").className = 'form-control correctNumber';
                await db.collection('video').doc().set(linkObject)
                Toast.fire({
                    type: 'info',
                    background: "#CDFFEC",
                    title: "Se ha compartido el video"
                });
    
                document.querySelector("#iLink").value = ''
                setLink('')
            } else {
                Toast.fire({
                    type: 'info',
                    background: "#FFB0B0",
                    title: "Clave inválida, porporciona una clave de vídeo válida"
                });
                document.querySelector("#iLink").className = 'form-control invalidNumber';
            }

           


        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Panel de Control'
    })





    return (



        <Fade in={true}>
            <Paper elevation={0}>


                <Fragment>
                    <div className='titleApp panel'>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}} className='row justify-content-center'>
                            <img src={logodv} style={{width:'100px'}} alt="Logo Iglesia de Dios (Israelita)" />
                            <h2 style={{fontWeight:'bold', color:'#242334'}}>Control panel</h2>
                        </div>
                    </div>

                    <div className='activitySection'>
                        <h4>Activities</h4>

                        <div className="services">
                            <CardService titleCard={'Works'}  url={'https://images.unsplash.com/photo-1482952980430-be6f9ff18749?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'} view={'/works/manage'} />
                            <CardService titleCard={'Reviews'}  url={'https://images.unsplash.com/photo-1585909695284-32d2985ac9c0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80'} view={'/reviews/manage'} />
                        </div>

                    </div>

                </Fragment>
            </Paper>
        </Fade>


    );



}


export default DashboardAdmin;